import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { withTheme } from 'styled-components';
import { rgba } from 'foundations-components/transitional/utils/color';
import { UITourPulserBorderShadow } from './UITourPulserElements';
import UITourPulserLayer from './UITourPulserLayer';
import UITourPulserOverlay from './UITourPulserOverlay';
import UITourPulserSpotlight from './UITourPulserSpotlight';
import { getAttachedElements } from '../utils/elementUtils';
import { usePulserContainer } from '../hooks/pulser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PULSER_BORDER_SHADOW_ID = 'pulser-border-shadow';
const POPOVER_DEFAULT_Z_INDEX = 1111;
const UITourPulser = /*#__PURE__*/forwardRef(({
  theme,
  attachTo,
  borderColor = theme.color['fill-accent-purple-default'],
  borderRadius = 3,
  borderSize = 3,
  enableBorder = true,
  enableOverlay = true,
  enablePulse: __enablePulse = true,
  pulserDistance = 6,
  pulserDuration = '2s',
  pulserOverlayColor = rgba(theme.color['temp-do-not-use-fill-surface-recessed'], 0.3),
  pulserPadding = 4,
  pulserZIndex = POPOVER_DEFAULT_Z_INDEX,
  target
}, ref) => {
  // Disable pulse animation when distance is 0
  const enablePulse = __enablePulse === true && pulserDistance !== 0;
  const pulserContainer = usePulserContainer(target);
  const pulserRef = useRef({});
  const pulserTargets = getAttachedElements(attachTo || target);
  const [shouldShowPulser, setShouldShowPulser] = useState(false);
  // expose showPulser to parent component
  // This is for showing pulser after tour step popover is opened
  useImperativeHandle(ref, () => ({
    showPulser: () => setShouldShowPulser(true)
  }), []);
  if (!pulserContainer) {
    return null;
  }
  return /*#__PURE__*/createPortal(
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsxs(UITourPulserLayer, {
    className: 'tour-pulser' + (shouldShowPulser ? " tour-pulser--visible" : ""),
    zIndex: pulserZIndex,
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx(UITourPulserBorderShadow, {
        borderColor: borderColor,
        borderShadowId: PULSER_BORDER_SHADOW_ID
      })
    }), enableOverlay &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(UITourPulserOverlay, {
      className: "tour-pulser-overlay",
      enablePulse: enablePulse,
      pulserDuration: pulserDuration,
      pulserOverlayColor: pulserOverlayColor,
      pulserRef: pulserRef
    }), pulserTargets.map((pulserTarget, index) =>
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(UITourPulserSpotlight, {
      className: "tour-pulser-border",
      borderColor: borderColor,
      borderSize: borderSize,
      borderShadowId: PULSER_BORDER_SHADOW_ID,
      enableBorder: enableBorder,
      pulserDistance: enablePulse ? pulserDistance : 0,
      pulserDuration: pulserDuration,
      pulserPadding: pulserPadding,
      pulserRadius: borderRadius,
      pulserRef: pulserRef,
      pulserTarget: pulserTarget
    }, index))]
  }), pulserContainer);
});
export default withTheme(UITourPulser);